import React from 'react';
import styled from 'styled-components';
import {useOutlet} from 'reconnect.js';
import NavUrl from 'rev.sdk.js/Utils/NavUrl';
import {updateQueries} from 'rev.sdk.js/Utils/updateQueries';
import qs from 'query-string';
import * as AppActions from '../../AppActions';

function cls(arr) {
  return arr.filter((item) => typeof item === 'string').join(' ');
}

export default function TopFilter(props) {
  const {cat, mobile = false, params} = props;
  const [categories] = useOutlet(props.categories);
  const prefixPath = props.prefixPath;
  const title_key = props.title_key;

  function updateRoute(options) {
    console.log('in update route', options);
    const nextQueryString = updateQueries({
      keys: ['cat', 'sort', 'search', 'q', 'page'],
      params,
      options,
    });

    let _nextUrl = `${prefixPath}${nextQueryString}`;
    let {url, query} = qs.parseUrl(_nextUrl);
    let navUrl = new NavUrl(url, query);
    AppActions.navigate(navUrl);
  }

  return (
    <Wrapper className={cls(['custom-FilterMenuTop', mobile && 'mobile'])}>
      <div className="content">
        <div className="title">{title_key && AppActions.L(title_key)}</div>
        <div className="items">
          {categories.map((catL1) => {
            return (
              <TopLevelCategory
                key={catL1.name}
                catL1={catL1}
                cat={cat}
                updateCat={(cat) => updateRoute({cat, page: ''})}
              />
            );
          })}
        </div>
      </div>
    </Wrapper>
  );
}

function TopLevelCategory(props) {
  const {catL1, cat, updateCat} = props;
  const [currL1] = (cat || '').split('-');
  const selected = currL1 === catL1.name;

  return (
    <Label
      className={cls(['L1', selected && 'selected'])}
      onClick={() => updateCat(catL1.name)}>
      {AppActions.F(catL1, 'display') || catL1.name}
    </Label>
  );
}

const Label = styled.div`
  background-color: transparent;
  border-radius: 0px;
  border: none;
  margin-left: 10px;
  /* display: flex;
    align-items: center; */
  cursor: pointer;
  transition: all 0.4s ease-in-out;
  word-break: keep-all;
  white-space: nowrap;
  padding: 16px 0;

  &:hover,
  &:active {
    font-weight: 500;
  }

  &.selected {
    color: var(--primaryColor);
  }
`;

const Wrapper = styled.div`
  position: sticky;
  top: var(--topNavBarHeight);
  padding: 0 50px;

  z-index: 1;
  background-color: var(--background-color);
  border-bottom: solid 0.75px var(--border-color);
  color: var(--text-4-color);
  letter-spacing: 0.2rem;

  & > .content {
    display: flex;
    align-items: flex-start;
    max-width: var(--contentMaxWidth);
    margin: 0 auto;
    // width: 100%;
    overflow-x: scroll;

    & > .title {
      flex: 1;
      word-break: keep-all;
      padding: 16px 0;

      &:first-letter {
        text-transform: uppercase;
      }
    }

    & > .items {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex-wrap: nowrap;
    }
  }

  &.mobile {
    padding: 0 20px;
  }
`;
